/* eslint-disable react-hooks/exhaustive-deps */
import styled from "styled-components";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as userActions from "../../redux/actions/userActions";
import * as settingsActions from "../../redux/actions/settingsActions";
import * as cartActions from "../../redux/actions/cartActions";
import CheckOutAccordionMenu from "./CheckOutAccordionMenu";
import ConfirmOrderComponent from "./ConfirmOrderComponent";
import DeliveryDetailsComponent from "./DeliveryDetailsComponent";
import DeliveryMethodComponents from "./DeliveryMethodComponents";
//003 ++ Check Out Page Payment Method Kotrolünün Eklenmesi.
import PaymentMethodComponent from "./PaymentMethodComponent";
//003 -- Check Out Page Payment Method Kotrolünün Eklenmesi.
import OrcaModal from "../Modal/OrcaModal";
import Charge from "../../pages/Charge";
import { API_URL } from "../../res/values/values";
import { colors } from "../../res/values/values";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";

import DatePicker, { registerLocale } from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import en from "date-fns/locale/en-GB";
import {
  format,
  addDays,
  subDays,
  addWeeks,
  subWeeks,
  setHours,
  setMinutes,
} from "date-fns";
import { forwardRef } from "react";
registerLocale("en", en);

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

//#region STYLES
const Container = styled.div`
  min-height: 40vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 30px;
`;
const Error = styled.div`
  margin: 5px;
  width: 88.5%;
  padding: 10px;
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 16px;
  font-weight: 300;
`;
const CurrentTime = styled.div`
  margin-bottom: 8px;
  color: ${colors.primaryColor};
  font-size: 16px;
  font-weight: 700;
  text-align: center;
`;
//#endregion

function CheckOutContent(props) {
  const navigate = useNavigate();
  const [deliveryDetailsOpenStatus, setDeliveryDetailsOpenStatus] =
    useState(true);
  //003 ++ Check Out Page Payment Method Kotrolünün Eklenmesi.
  const [paymentMethodOpenStatus, setPaymentMethodOpenStatus] = useState(false);
  const [cashOnDelivery,setCashOnDelivery] = useState(false)
  const [paymentMethod, setPaymentMethod] = useState("Card");
  //003 -- Check Out Page Payment Method Kotrolünün Eklenmesi.
  const [deliveryMethodOpenStatus, setDeliveryMethodOpenStatus] =
    useState(false);
  const [confirmOrderOpenStatus, setConfirmOrderOpenStatus] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [deliveryMethod, setDeliveryMethod] = useState("");
  const [checkOutError, setCheckOutError] = useState("");

  const [loading, setLoading] = useState(true);

  const [colDelDate, SetColDelDate] = useState(new Date());
  const [visibleDatePicker, setVisibleDatePicker] = useState(false);
  const [delDayList, setDelDayList] = useState(new Date());
  const [firstDeliveryDate, setFirstDeliveryDate] = useState(null);
  const [deliveryError, setDeliveryError] = useState(false);
  const [alertMessage, setAlertMessage] = useState(false);
  const [open, setOpen] = useState(false);

  const minTime = new Date();
  minTime.setHours(6, 0, 0); // Minimum saat: 08:00

  const maxTime = new Date();
  maxTime.setHours(18, 30, 0); // Maksimum saat: 22:00

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    async function getAPI() {
      await props.actions.getSettings();
      props.cart.length > 0
        ? setDeliveryMethod(props.cart[0].deliverymethod)
        : setDeliveryMethod("");
      const access_token = localStorage.getItem("access_token");
      if (access_token) await props.actions.getUser();
      await setDeliveryDayList(props.cart[0].deliverymethod);
      setLoading(false);
    }
    getAPI();
    return () => {
      //alert('DEAD')
    };
  }, []);

  const continueDeliveryDetails = (status) => {
    setDeliveryDetailsOpenStatus(!status);
    setPaymentMethodOpenStatus(status);
  };
  //003 ++ Check Out Page Payment Method Kotrolünün Eklenmesi.
  const continuePaymetMethod = (status) => {
    if(!cashOnDelivery && deliveryMethod==='Delivery'){
      setAlertMessage('In order to continue, you must choose cash on delivery because your delivery method selection is delivery !')
      setDeliveryError(true)
    }else{
      setPaymentMethodOpenStatus(!status);
      setDeliveryMethodOpenStatus(status);
      setVisibleDatePicker(true);
    }
    
  };
  //003 ++ Check Out Page Payment Method Kotrolünün Eklenmesi.
  const continueDeliveryMethod = (status) => {
    setDeliveryMethodOpenStatus(!status);
    setConfirmOrderOpenStatus(status);
  };
  const changePaymentMethod = (status) => {
    setPaymentMethod(status);
  };
  const changeDeliveryMethod = async (deliverymethod) => {
    if(props.currentUser.deliveryDates.length === 0) {
      setDeliveryError(true)
      setAlertMessage('Your delivery days is unknown !')
      return;
    }
    if (
      !props.currentUser.deliveryDates[0].monday &&
      !props.currentUser.deliveryDates[0].tuesday &&
      !props.currentUser.deliveryDates[0].wednesday &&
      !props.currentUser.deliveryDates[0].thursday &&
      !props.currentUser.deliveryDates[0].friday &&
      !props.currentUser.deliveryDates[0].saturday &&
      !props.currentUser.deliveryDates[0].sunday &&
      deliverymethod === "Delivery"
    ){
      setDeliveryError(true)
      setAlertMessage('Your delivery days is unknown !')
    }
     
    else {
      if(!cashOnDelivery && deliverymethod==='Delivery'){
        setAlertMessage('In order to continue, you must choose cash on delivery because your delivery method selection is delivery !')
        setDeliveryError(true)
        setPaymentMethodOpenStatus(true)
        setDeliveryMethodOpenStatus(false)
      }else{
        await props.actions.updateCartDeliveryMethod(deliverymethod);
        setDeliveryMethod(deliverymethod)
        if (deliverymethod === "Collection") {
          SetColDelDate(new Date());
          setVisibleDatePicker(true);
        } else {
          SetColDelDate(firstDeliveryDate);
          setVisibleDatePicker(true);
        }
      }
      
    }
  };
  const getTotalAmount = () => {
    let totalAmountInclVat = 0;
    props.cart.map((item) => (totalAmountInclVat += item.lineamountinclvat));
    return totalAmountInclVat.toFixed(2);
  };
  const confirmOrder = async () => {
    if (props.settings.payment) handleOpen();
    else {
      let user = {
        id: props.currentUser.id,
        customerno: props.currentUser.customerno,
        email: props.currentUser.email,
        address:
          selectedAddress !== ""
            ? selectedAddress
            : props.currentUser.adrressList[0].value,
        deliveryMethod: deliveryMethod,
        requestedCollectionDate:
          deliveryMethod === "Collection"
            ? format(colDelDate, "dd/MM/yyyy HH:mm")
            : "",
        requestedDeliveryDate: deliveryMethod === "Delivery" ? format(colDelDate, "dd/MM/yyyy HH:mm") : "",
      };
      debugger
      const access_token = localStorage.getItem("access_token");
      let url = `${API_URL}/cart/checkout`;
      await fetch(url, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer: ${access_token}`,
        },
        body: JSON.stringify(user),
      })
        .then((res) => res.json())
        .then(async (res) => {
          if (res.success) await successPostOrder();
          else {
            setCheckOutError(res.message);
            if (
              res.message === "You are not authorization to access this route"
            ) {
              navigate("/route=account/login", {
                state: { href: window.location.href },
              });
            }
          }
        })
        .catch((err) => {
          let error = JSON.parse(err.message);
          console.log("CATCH : " + error);
        });
    }
  };
  const successPostOrder = async () => {
    await props.actions.getCartList();
    navigate("/route=account/order");
  };
  const confirmOrderWithPayment = async () => {
    let user = {
      id: props.currentUser.id,
      customerno: props.currentUser.customerno,
      email: props.currentUser.email,
      address:
        selectedAddress !== ""
          ? selectedAddress
          : props.currentUser.adrressList[0].value,
      deliveryMethod: deliveryMethod,
      requestedCollectionDate:
          deliveryMethod === "Collection"
            ? format(colDelDate, "dd/MM/yyyy HH:mm")
            : "",
        requestedDeliveryDate: deliveryMethod === "Delivery" ? format(colDelDate, "dd/MM/yyyy HH:mm") : "",
    };
    //await props.actions.checkOutOrder(user)
    const access_token = localStorage.getItem("access_token");
    let url = `${API_URL}/cart/checkout`;
    await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer: ${access_token}`,
      },
      body: JSON.stringify(user),
    })
      .then((res) => res.json())
      .then(async (res) => {
        if (res.success) await successPostOrder();
        else {
          setCheckOutError(res.message);
          if (
            res.message === "You are not authorization to access this route"
          ) {
            navigate("/route=account/login", {
              state: { href: window.location.href },
            });
          }
        }
      })
      .catch((err) => {
        let error = JSON.parse(err.message);
        console.log("CATCH : " + error);
      });
  };
  const checkDay = (dayList, day) => {
    let rv = false;
    switch (day) {
      case "Monday":
        dayList.forEach((day) => {
          if (day.monday) rv = true;
        });
        break;
      case "Tuesday":
        dayList.forEach((day) => {
          if (day.tuesday) rv = true;
        });
        break;
      case "Wednesday":
        dayList.forEach((day) => {
          if (day.wednesday) rv = true;
        });
        break;
      case "Thursday":
        dayList.forEach((day) => {
          if (day.thursday) rv = true;
        });
        break;
      case "Friday":
        dayList.forEach((day) => {
          if (day.friday) rv = true;
        });
        break;
      case "Saturday":
        dayList.forEach((day) => {
          if (day.saturday) rv = true;
        });
        break;
      case "Sunday":
        dayList.forEach((day) => {
          if (day.sunday) rv = true;
        });
        break;
      default:
        rv = false;
    }
    return rv;
  };
  const setDeliveryDayList = async (deliveryMethod) => {
    debugger
    let firstday = null;
    let dayList = [];
    for (let i = 1; i < 120; i++) {
      let date = addDays(new Date(), i);
      let day = format(date, "EEEE");
      if (props.currentUser.deliveryDates.length > 0) {
        // eslint-disable-next-line default-case
        switch (day) {
          case "Monday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Tuesday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Wednesday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Thursday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Friday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Saturday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
          case "Sunday":
            if (checkDay(props.currentUser.deliveryDates, day)) {
              if (!firstday) {
                firstday = date;
                setFirstDeliveryDate(date);
                deliveryMethod === "Delivery" && SetColDelDate(date);
              }
              dayList.push(date);
            }
            break;
        }
      }

      i === 119 && setDelDayList(dayList);
    }
  };
  const isWeekday = (date) => {
    const day = date.getDay();
    // Cumartesi 6'dır, Pazar 0'dır.
    return day !== 6;
  };
  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedTime = new Date(time);
    // 1 saat 30 dakika ekle
    currentDate.setHours(currentDate.getHours() + 1);
    currentDate.setMinutes(currentDate.getMinutes() + 30);
    return currentDate <= selectedTime;
  };
  return (
    <div>
      {!loading ? (
        <Container>
          {deliveryMethod === "Collection" ? (
            <OrcaModal isOpen={visibleDatePicker} onClose={handleClose}>
              <DatePicker
                open={visibleDatePicker}
                selected={colDelDate}
                onChange={(date) => {
                  const now = new Date();
                  if (now > date) {
                    setDeliveryError(true);
                    setAlertMessage("You cannot select past dates !");
                  } else SetColDelDate(date);
                }}
                locale="en"
                inline
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={30}
                dateFormat="dd/MM/yyyy HH:mm"
                minDate={new Date()}
                minTime={minTime}
                maxTime={maxTime}
                todayButton="today"
                filterDate={isWeekday}
                filterTime={filterPassedTime} // Geçmiş zamanları filtrele
              />
              <button
                onClick={() => {
                  setVisibleDatePicker(false);
                }}
                style={{
                  backgroundColor: "white",
                  padding: 10,
                  width: "100%",
                  marginTop: 20,
                }}
              >
                OK
              </button>
            </OrcaModal>
          ) : (
            <OrcaModal isOpen={visibleDatePicker} onClose={handleClose}>
              <CurrentTime>
                {deliveryMethod === "Collection"
                  ? format(colDelDate, "dd/MM/yyyy HH:mm")
                  : format(colDelDate, "dd/MM/yyyy")}
              </CurrentTime>

              <DatePicker
                open={visibleDatePicker}
                selected={colDelDate}
                onChange={(date) => {
                  let day = format(date, "EEEE");
                  // eslint-disable-next-line default-case
                  switch (day) {
                    case "Monday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }

                      break;
                    case "Tuesday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }
                      break;
                    case "Wednesday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }
                      break;
                    case "Thursday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }

                      break;
                    case "Friday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }

                      break;
                    case "Saturday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }

                      break;
                    case "Sunday":
                      if (checkDay(props.currentUser.deliveryDates, day))
                        SetColDelDate(date);
                      else {
                        setDeliveryError(true);
                        setAlertMessage(
                          "It is not a valid delivery day. Please select a valid delivery day."
                        );
                      }

                      break;
                  }
                }}
                locale="en"
                inline
                disabledKeyboardNavigation
                minDate={addDays(new Date(), 1)}
                maxDate={addDays(new Date(), 119)}
                highlightDates={delDayList}
              />
              <button
                onClick={() => {
                  setVisibleDatePicker(false);
                }}
                style={{
                  backgroundColor: "white",
                  padding: 10,
                  width: "100%",
                  marginTop: 20,
                }}
              >
                OK
              </button>
            </OrcaModal>
          )}

          <OrcaModal isOpen={open} onClose={handleClose}>
            <Charge
              totalPayment={getTotalAmount}
              confirmOrderWithPayment={confirmOrderWithPayment}
              user={{
                name: props.currentUser.firstname,
                email: props.currentUser.email,
                address:
                  selectedAddress !== ""
                    ? selectedAddress
                    : props.currentUser.adrressList[0].value,
              }}
            />
          </OrcaModal>

          {checkOutError !== "" && <Error>{checkOutError}</Error>}
          <CheckOutAccordionMenu
            isActive={deliveryDetailsOpenStatus}
            key={"COT1"}
            a={"COT1"}
            item={{
              title: "Delivery Details",
              content: (
                <DeliveryDetailsComponent
                  changeOpenStatus={continueDeliveryDetails}
                  dropDownList={
                    props.currentUser.adrressList
                      ? [...props.currentUser.adrressList]
                      : []
                  }
                  selectedAddress={selectedAddress}
                  setSelectedAddress={setSelectedAddress}
                />
              ),
            }}
          />
          <CheckOutAccordionMenu
            isActive={paymentMethodOpenStatus}
            key={"COT2"}
            a={"COT2"}
            item={{
              title: "Payment Method",
              content: (
                <PaymentMethodComponent
                  setCashOnDelivery={setCashOnDelivery}
                  cashOnDelivery={cashOnDelivery}
                  changeOpenStatus={continuePaymetMethod}
                />
              ),
            }}
          />
          <CheckOutAccordionMenu
            isActive={deliveryMethodOpenStatus}
            key={"COT3"}
            a={"COT3"}
            item={{
              title: "Delivery Method",
              content: (
                <DeliveryMethodComponents
                  deliveryMethod={deliveryMethod}
                  setDeliveryMethod={setDeliveryMethod}
                  changeOpenStatus={continueDeliveryMethod}
                  changeDeliveryMethod={changeDeliveryMethod}
                  requestedDate={colDelDate}
                  setVisibleDatePicker={setVisibleDatePicker}
                />
              ),
            }}
          />
          <CheckOutAccordionMenu
            isActive={confirmOrderOpenStatus}
            key={"COT4"}
            a={"COT4"}
            item={{
              title: "Confirm Order",
              content: (
                <ConfirmOrderComponent confirmOrderClick={confirmOrder} />
              ),
            }}
          />
          <Stack spacing={2} sx={{ width: "100%" }}>
            <Snackbar
              open={deliveryError}
              autoHideDuration={2000}
              onClose={() => setDeliveryError(false)}
            >
              <Alert
                onClose={() => setDeliveryError(false)}
                severity="error"
                sx={{ width: "100%", padding: "18px 16px" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Stack>
        </Container>
      ) : (
        <Container></Container>
      )}
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getUser: bindActionCreators(userActions.getUser, dispatch),
      getSettings: bindActionCreators(settingsActions.getSettings, dispatch),
      updateCartDeliveryMethod: bindActionCreators(
        cartActions.updateCartDeliveryMethod,
        dispatch
      ),
      getCartList: bindActionCreators(cartActions.getCartList, dispatch),
    },
  };
}
function mapStateToProps(state) {
  return {
    currentUser: state.currentUserReducer,
    cart: state.cartActionReducer,
    settings: state.settingReducer,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CheckOutContent);
